import React, { useEffect, useState } from 'react';
import { IoFilterSharp } from "react-icons/io5";
import { loadNFTsForaCollection } from '../../assets/Data/NFT';
import { getAirDropHistory } from '../../hooks/Collectionhook';
import { FiChevronDown, FiChevronUp } from 'react-icons/fi';
import { getDataFromURI } from '../../hooks/Tokenhook';
import { getUserByAddress } from '../../hooks/User';
import logo from "../../assets/img/avatars/avatar_1.png";

const DataOption = [
  { text: "Price low to high" },
  { text: "price high to low" },
  { text: "recently Listed" },
  { text: "Best Offer" },
  { text: "Highest last sale" },
];

const ActivitySideBar = [
  { key: "All", value: "All" },
  { key: "AirDrop", value: "aireDrop" }

]

export const CollectionActivityDrop = (props) => {
  const [nftCount, setNftCount] = useState(0);
  const [history, setHistory] = useState([]);
  const [openPanel, setOpenPanel] = useState('status');

  const collectionAddress = props.contractAddress

  useEffect(() => {
    // fetchNFTs();
    // History()
  }, [collectionAddress]);

  const fetchNFTs = async () => {
    const updatedNFTs = await loadNFTsForaCollection(collectionAddress);
    setNftCount(updatedNFTs.length);
  };

  const History = async () => {
    await getAirDropHistory(collectionAddress).then(async (data) => {
      if (data.data.status === 200) {
        // setHistory(data.data.data)
        const updatedNFTs = await Promise.all(data.data.data.map(async (item) => {
          const res = await getDataFromURI(item.tokenURI);
          const userResponseFrom = await getUserByAddress(item.initialOwner);
          const userResponseTo = await getUserByAddress(item.owner);
          if (res.status === 200) {
            const data = res.data;
            return {
              ...item,
              title: data.title,  
              image: data.image,
              type: data.type,
              category: data.category,
              desc: data.desc,
              price: data.price ? data.pricce : "---",
              rarity: data.rarity ? data.rarity : "---",
              from: userResponseFrom.user ? userResponseFrom.user.name : item.from.slice(-5),
              to: userResponseTo.user ? userResponseTo.user.name : item.to && item.to.slice(-5),
              tokenId: item.tokenId,
              creatorName: data.creator ? data.creator : "---"
            };
          }
        }));
        setHistory(updatedNFTs)
      }
    })
  };

  const togglePanel = (panelId) => {
    setOpenPanel(openPanel === panelId ? '' : panelId);
  };

  const filterStatus = () => {

  }
  const handleError = (event) => {
    event.target.src = logo;
  };
  return (
    <div className="Collection_content">
      <div className="items-content">
        <div className='d-flex align-items-center gap-2 live_show'>
          <div className="sidebar_button">
            <IoFilterSharp size={18} />
          </div>
          <div className="status">
            <div className="status-indicator">
              <div className="gif">
              </div>
            </div>
            <div className="status-text">Live</div>
          </div>
        </div>
        <div className='d-flex align-items-center'>
          <input type="text" className="search_bar" placeholder="Search..." />
        </div>
        <div className='d-flex align-items-center gap-2'>
          <div className="result-text">{history.length} results </div>
          <select className="dropdown">
            {DataOption.map((data) => (
              <option>{data.text}</option>
            ))}
          </select>
        </div>
      </div>
      <div className='row'>
        <div className='col-sm-12 col-md-4 col-lg-3'>

          <div className="panel-container mt-3">
            <div className="panel-header" onClick={() => togglePanel('status')}>
              <p className=''> Status </p>
              <span>
                {openPanel === 'status' ? <FiChevronUp size={21} /> : <FiChevronDown size={21} />}
              </span>
            </div>
            {openPanel === 'status' && (
              <div className="panel-body d-flex">
                {ActivitySideBar.map((item, index) => (
                  <div key={index} >
                    <div className="btn btn-sm btn-secondary mx-2">
                      <span className="" style={{ textTransform: "capitalize" }} onClick={() => filterStatus(item.value)}>{item.key}</span>
                      {/* <span>{item.value}</span> */}
                    </div>
                  </div>
                ))}

              </div>
            )}
          </div>
        </div>
        <div className='col-sm-12 col-md-8 col-lg-9'>
          <div className="panel-container mt-3">
            {/* {openPanel === 'history' && ( */}
            <div className="panel-body">
              <div className="trait">
                {history.length !== 0 ?
                  <div className="table-responsive">
                    <table
                      id="user-list-table"
                      className="table table-hover"
                      // role="grid"
                      data-toggle="data-table">
                      <thead>
                        <tr>
                          <th className='text-center'></th>
                          <th className='text-center'>Status</th>
                          <th className='text-center'>Item</th>
                          <th className='text-center'>Price</th>
                          <th className='text-center'>Rarity</th>
                          <th className='text-center'>Quantity</th>
                          <th className='text-center'>From</th>
                          <th className='text-center'>To</th>
                          <th className='text-center'>Time</th>
                        </tr>
                      </thead>
                      <tbody>
                        {history.map((item, index) => (
                          <tr key={index}>
                            <td className='text-center'>
                              <svg height="18" width="17" viewBox="0 0 20 21" xmlns="http://www.w3.org/2000/svg" class="sc-1b81fbb6-0 brCKo">
                                <path d="M10.625 8V13H11.875C12.1484 13 12.3828 13.0781 12.6172 13.1953L17.3047 8H16.2109C16.2109 7.80469 16.25 7.60938 16.25 7.375C16.25 4.91406 15.3516 2.64844 13.9844 1.16406C17.5781 2.45312 19.2578 5.30469 19.8047 7.29688C19.9219 7.6875 19.6094 8 19.2578 8H19.0234L13.5156 14.0547C13.6719 14.2891 13.75 14.6016 13.75 14.875V18.625C13.75 19.6797 12.8906 20.5 11.875 20.5H8.08594C7.07031 20.5 6.21094 19.6797 6.21094 18.625V14.875C6.21094 14.6016 6.28906 14.2891 6.44531 14.0547L0.9375 8H0.703125C0.351562 8 0.0390625 7.6875 0.15625 7.29688C0.703125 5.30469 2.38281 2.45312 5.97656 1.16406C4.60938 2.64844 3.75 4.91406 3.75 7.375C3.75 7.60938 3.75 7.80469 3.75 8H2.65625L7.34375 13.1953C7.57812 13.0781 7.8125 13 8.08594 13H9.33594V8H5C5 7.80469 4.96094 7.60938 4.96094 7.375C4.96094 5.38281 5.58594 3.66406 6.5625 2.41406C7.5 1.16406 8.71094 0.5 9.96094 0.5C11.25 0.5 12.4609 1.16406 13.3984 2.41406C14.375 3.66406 15 5.38281 15 7.375C15 7.60938 14.9609 7.80469 14.9609 8H10.625Z">
                                </path>
                              </svg>
                            </td>
                            <td className='text-center'>Air Drop</td>
                            <td className='text-ceter'>
                              <div className='d-flex'>
                                <div>

                                  <img src={item.image} onError={handleError} width={"50px"} height={"50px"} style={{ borderRadius: "0.3rem" }} className='mx-2' alt="" />
                                </div>
                                <div>
                                  <p className='text-start'>{item.title}</p>
                                  <span className='text-start'>{item.creatorName}</span>
                                </div>
                              </div>
                            </td>
                            <td className='text-center'>{item.price}</td>
                            <td className='text-center'>{item.rarity}</td>
                            <td className='text-center'>1</td>
                            <td className='text-center'>{item.from}</td>
                            <td className='text-center'>{item.to}</td>
                            <td className='text-center'>---</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  :
                  <h4>
                    Loading...
                  </h4>
                }
              </div>

            </div>
            {/* )} */}
          </div>
        </div>
      </div>
    </div>
  )
};
